import React from "react";

/**
 * Wrapper component that provides consistent delete animation styling
 * Applies fade-out and scale-down effects when an item is being deleted
 *
 * @param {Object} props - Component props
 * @param {string|number} props.itemId - The ID of the item
 * @param {boolean} props.isDeleting - Whether the item is currently being deleted
 * @param {React.ReactNode} props.children - The content to wrap
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {number} props.animationDuration - Duration of the animation in milliseconds (default: 300)
 */
const DeleteAnimationWrapper = ({
  itemId,
  isDeleting,
  children,
  className = "",
  style = {},
  animationDuration = 300,
}) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        transformOrigin: "top center",
        transition: `all ${animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        opacity: isDeleting ? 0 : 1,
        transform: isDeleting
          ? "scale(0.95) translateY(-8px)"
          : "scale(1) translateY(0)",
        pointerEvents: isDeleting ? "none" : "auto",
        willChange: "transform, opacity",
      }}
    >
      {children}
    </div>
  );
};

export default DeleteAnimationWrapper;
